<template>
  <b-modal
    centered
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    v-model="show"
    @close="closeModal"
    class="pa-4"
    :style="'width: 708px !important;'"
  >
    <template #modal-title>
      <h3 class="font-weight-bold">Send Request</h3>
    </template>
    <b-card
      no-body
      v-cloak
      class="rounded-0 border-0 mx-0 bg-light"
      @drop.prevent=""
      @dragover.prevent
    >
      <b-form @submit.prevent="sendRequest">
        <div v-if="template">
          <h3 class="font-weight-bold mt-4">Add due date</h3>
          <b-form-datepicker
            id="input-date"
            type="date"
            locale="en-AU"
            today-button
            reset-button
            no-flip
            :show-decade-nav="true"
            placeholder="dd/mm/yyyy"
            aria-describedby="input-date-feedback"
            v-model="form.due_date"
            :min="minDueDate"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            @input="onDateChanged"
          />
          <span class="invalid-feedback d-block">
            {{ dateInvalid }}
          </span>

          <h3 class="font-weight-bold mt-4">Add instruction</h3>
          <b-form-textarea
            id="input-title"
            type="text"
            v-model="form.instruction"
            required
            placeholder="Instructions"
            class="font-weight-normal mb-2"
            rows="5"
          ></b-form-textarea>
        </div>
        <div class="my-4 mx-0">
          <b-container>
            <b-row>
              <b-col cols="12" md="5" class="mb-md-4 mb-3">
                <b-button
                  class="w-100 btn-outlined bg-white text-dark"
                  variant="outline-secondary"
                  :style="'height: 64px !important;'"
                  :disabled="loading"
                  @click="clearForm"
                >
                  Clear
                </b-button>
              </b-col>
              <b-col cols="12" md="2" class="mb-0"></b-col>
              <b-col cols="12" md="5" class="mb-md-4 mb-3">
                <b-button
                  type="submit"
                  class="w-100 h-auto float-right py-3"
                  variant="primary"
                  :style="'height: 64px !important;'"
                  :loading="loading"
                  :disabled="loading || !emails.length || dateInvalid != null"
                >
                  Send
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-form>
    </b-card>
  </b-modal>
</template>

<script>
import Form from '@/utils/form'

export default {
  name: 'SendRequestModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    template: {
      type: Object,
      default: null,
    },

    emails: {
      default: [''],
    },

    // When the request is raised from a project's tradie page, pass the
    // project name so it's recorded on the FileRequest (matches the
    // server-side auto-request). Without it the API can't tie the request
    // back to a project — e.g. to lift a per-tradie required-file waiver
    // when the file is re-requested.
    projectName: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      form: new Form({
        name: '',
        project: null,
        uploadType: null,
        emails: [],
        due_date: null,
        instruction: null,
        template_id: null,
        information_types: null,
      }),
      validTags: [],
      invalidTags: [],
      maxTags: [],
      tagErrors: {
        message: null,
        error_code: null,
      },
      search: '',
      selectedInfoTypes: [],
      dateInvalid: null,
    }
  },

  computed: {
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.$emit('closeModal')
      },
    },

    minDueDate() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return today
    },
  },

  methods: {
    closeModal() {
      this.clear()
      this.$emit('closeModal')
    },

    clearSendRequestErrorEmails() {
      this.invalidTags = []
      this.maxTags = []
      this.tagErrors = {
        message: null,
        error_code: null,
      }
    },

    clear() {
      this.clearSendRequestErrorEmails()
    },

    clearForm() {
      this.form.due_date = null
      this.form.instruction = null
    },

    onDateChanged() {
      this.dateInvalid = null
    },

    async sendRequest() {
      if (this.form.due_date === null) {
        this.dateInvalid = 'Please input a valid date'
        return
      }

      this.dateInvalid = null
      this.loading = true
      this.form.$busy = true

      const [year, month, day] = this.form.due_date.split('-')
      const formattedDate = `${day}/${month}/${year}`

      this.form.project = this.projectName || undefined
      this.form.name = this.template.label
      this.form.template_id = this.template.id
      this.form.due_date = formattedDate
      this.form.emails = this.emails

      await this.$api
        .post('file-request', this.form.$data())
        .then((res) => {
          this.$emit('sendRequestResponse', res.data)
          this.clear()
          this.closeModal()
        })
        .catch((error) => {
          this.form.$handleError(error)
        })
        .finally(() => {
          this.loading = false
          this.form.$busy = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ #input-date__value_ {
  align-content: center;
}
</style>
